import { CLOSE_MODAL, OPEN_MODAL } from 'constants/actions';
import { EDIT_CLICK_ADD_CLIP } from 'constants/events';
import { ADD_LOOM_SEARCH_MODAL } from 'constants/modalTypes';
import * as analytics from 'utilities/analytics';

export const openModal = (modalType, options = {}) => {
  if (modalType === ADD_LOOM_SEARCH_MODAL) {
    analytics.track(EDIT_CLICK_ADD_CLIP, { id: options.videoId });
  }

  return {
    type: OPEN_MODAL,
    payload: {
      modalType,
      options,
    },
  };
};

export const closeModal = () => ({
  type: CLOSE_MODAL,
});
